(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7410,5664],{

/***/ "./node_modules/embla-carousel-autoplay/embla-carousel-autoplay.esm.js":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Autoplay; }
/* harmony export */ });
const defaultOptions = {
  active: true,
  breakpoints: {},
  delay: 4000,
  jump: false,
  playOnInit: true,
  stopOnInteraction: true,
  stopOnMouseEnter: false,
  stopOnLastSnap: false,
  rootNode: null
};

function Autoplay(userOptions = {}) {
  let options;
  let carousel;
  let interaction;
  let timer = 0;
  let jump = false;
  function init(embla, optionsHandler) {
    carousel = embla;
    const {
      mergeOptions,
      optionsAtMedia
    } = optionsHandler;
    const optionsBase = mergeOptions(defaultOptions, Autoplay.globalOptions);
    const allOptions = mergeOptions(optionsBase, userOptions);
    options = optionsAtMedia(allOptions);
    jump = options.jump;
    interaction = options.stopOnInteraction ? destroy : stop;
    const {
      eventStore
    } = carousel.internalEngine();
    const emblaRoot = carousel.rootNode();
    const root = options.rootNode && options.rootNode(emblaRoot) || emblaRoot;
    carousel.on('pointerDown', interaction);
    if (!options.stopOnInteraction) carousel.on('pointerUp', reset);
    if (options.stopOnMouseEnter) {
      eventStore.add(root, 'mouseenter', interaction);
      if (!options.stopOnInteraction) eventStore.add(root, 'mouseleave', reset);
    }
    eventStore.add(document, 'visibilitychange', () => {
      if (document.visibilityState === 'hidden') return stop();
      reset();
    });
    eventStore.add(window, 'pagehide', event => {
      if (event.persisted) stop();
    });
    if (options.playOnInit) play();
  }
  function destroy() {
    carousel.off('pointerDown', interaction);
    if (!options.stopOnInteraction) carousel.off('pointerUp', reset);
    stop();
    timer = 0;
  }
  function play(jumpOverride) {
    stop();
    if (typeof jumpOverride !== 'undefined') jump = jumpOverride;
    timer = window.setTimeout(next, options.delay);
  }
  function stop() {
    if (!timer) return;
    window.clearTimeout(timer);
  }
  function reset() {
    if (!timer) return;
    stop();
    play();
  }
  function next() {
    const {
      index
    } = carousel.internalEngine();
    const kill = options.stopOnLastSnap && index.get() === index.max;
    if (kill) return destroy();
    if (carousel.canScrollNext()) {
      carousel.scrollNext(jump);
    } else {
      carousel.scrollTo(0, jump);
    }
    play();
  }
  const self = {
    name: 'autoplay',
    options: userOptions,
    init,
    destroy,
    play,
    stop,
    reset
  };
  return self;
}
Autoplay.globalOptions = undefined;


//# sourceMappingURL=embla-carousel-autoplay.esm.js.map


/***/ }),

/***/ "./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Fcategories%2F%5Bcategory%5D.tsx&page=%2Fcategories%2F%5Bcategory%5D!":
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categories/[category]",
      function () {
        return __webpack_require__("./src/pages/categories/[category].tsx");
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ "./src/components/Elements/Carousel/Carousel.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ WikiCarousel; },
/* harmony export */   "l": function() { return /* binding */ Carousel; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./node_modules/@chakra-ui/button/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./node_modules/@chakra-ui/icon/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("./node_modules/@chakra-ui/system/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var embla_carousel_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./node_modules/embla-carousel-react/embla-carousel-react.esm.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var react_icons_ri__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("./node_modules/react-icons/md/index.esm.js");
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/react-slick/lib/index.js");
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("./node_modules/react-icons/fa/index.esm.js");
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/slick-carousel/slick/slick.css");
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./node_modules/slick-carousel/slick/slick-theme.css");
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__);











const WikiCarousel = (param)=>{
    let { data , item , options , plugins , Buttons  } = param;
    const [emblaRef, emblaApi] = (0,embla_carousel_react__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ...options
    }, plugins);
    const [selectedIndex, setSelectedIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [scrollSnaps, setScrollSnaps] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [prevBtnEnabled, setPrevBtnEnabled] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [nextBtnEnabled, setNextBtnEnabled] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const scrollTo = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((index)=>{
        return emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.scrollTo(index);
    }, [
        emblaApi
    ]);
    const onSelect = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        if (!emblaApi) return;
        setSelectedIndex(emblaApi.selectedScrollSnap());
        setPrevBtnEnabled(emblaApi.canScrollPrev());
        setNextBtnEnabled(emblaApi.canScrollNext());
    }, [
        emblaApi,
        setSelectedIndex
    ]);
    const scrollPrev = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        return emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.scrollPrev();
    }, [
        emblaApi
    ]);
    const scrollNext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        return emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.scrollNext();
    }, [
        emblaApi
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!emblaApi) return;
        onSelect();
        setScrollSnaps(emblaApi.scrollSnapList());
        emblaApi.on("select", onSelect);
        emblaApi.on("reInit", onSelect);
    }, [
        emblaApi,
        setScrollSnaps,
        onSelect
    ]);
    const PrevButton = (props)=>{
        const { enabled , onClick  } = props;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Button */ .zx, {
            className: "embla__button embla__button--prev",
            onClick: onClick,
            disabled: !enabled,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Icon */ .JO, {
                as: react_icons_md__WEBPACK_IMPORTED_MODULE_8__/* .MdOutlineArrowBackIos */ .oTp
            })
        });
    };
    const NextButton = (props)=>{
        const { enabled , onClick  } = props;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Button */ .zx, {
            className: "embla__button embla__button--next",
            onClick: onClick,
            disabled: !enabled,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Icon */ .JO, {
                as: react_icons_md__WEBPACK_IMPORTED_MODULE_8__/* .MdOutlineArrowForwardIos */ .Djl
            })
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .chakra.div */ .m$.div, {
                ref: emblaRef,
                overflow: "hidden",
                w: "full",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Flex */ .kC, {
                    w: "full",
                    children: data === null || data === void 0 ? void 0 : data.map((e, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .xu, {
                            flex: "0 0 auto",
                            minW: "0",
                            maxW: "100%",
                            children: item(e)
                        }, i))
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Flex */ .kC, {
                w: "full",
                alignItems: "center",
                gap: "3",
                pt: "4",
                justifyContent: "center",
                children: scrollSnaps.map((_, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Icon */ .JO, {
                        as: react_icons_ri__WEBPACK_IMPORTED_MODULE_11__/* .RiCheckboxBlankCircleFill */ .o$3,
                        fontSize: "8px",
                        color: index !== selectedIndex ? "brand.200" : "brand.500",
                        cursor: "pointer",
                        onClick: ()=>scrollTo(index)
                    }, index))
            }),
            Buttons && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PrevButton, {
                        onClick: scrollPrev,
                        enabled: prevBtnEnabled
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NextButton, {
                        onClick: scrollNext,
                        enabled: nextBtnEnabled
                    })
                ]
            })
        ]
    });
};
const ArrowBtn = (param)=>/*#__PURE__*/ {
    let { ArrowIcon , onClick , top , isNext  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .xu, {
        top: top,
        position: "absolute",
        transform: "translate(0, 150%)",
        display: "grid",
        placeItems: "center",
        onClick: onClick,
        cursor: "pointer",
        borderWidth: "1px",
        borderColor: "carouselArrowBorderColor",
        zIndex: 99,
        bgColor: "carouselArrowBg",
        borderRadius: "50%",
        w: "40px",
        h: "40px",
        right: isNext ? "-20px" : "unset",
        left: isNext ? "unset" : "-20px",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Icon */ .JO, {
            as: ArrowIcon,
            color: "grey"
        })
    });
};
const Carousel = (param)=>/*#__PURE__*/ {
    let { settings , children , topArrow  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        ...settings,
        nextArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ArrowBtn, {
            top: topArrow,
            ArrowIcon: react_icons_fa__WEBPACK_IMPORTED_MODULE_12__/* .FaChevronRight */ .Dli,
            isNext: true
        }),
        prevArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ArrowBtn, {
            top: topArrow,
            ArrowIcon: react_icons_fa__WEBPACK_IMPORTED_MODULE_12__/* .FaChevronLeft */ .bUI
        }),
        children: children
    });
};


/***/ }),

/***/ "./src/components/Wiki/WikiPreviewCard/WikiPreviewCard.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var _utils_DataTransform_getFormattedDate__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("./src/utils/DataTransform/getFormattedDate.ts");
/* harmony import */ var _components_Elements_Avatar_DisplayAvatar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/components/Elements/Avatar/DisplayAvatar.tsx");
/* harmony import */ var _hooks_useENSData__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/hooks/useENSData.ts");
/* harmony import */ var _utils_textUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/textUtils.ts");
/* harmony import */ var _components_Elements__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/components/Elements/index.ts");
/* harmony import */ var _components_Elements_LinkElements_LinkOverlay__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/components/Elements/LinkElements/LinkOverlay.tsx");
/* harmony import */ var _utils_DataTransform_getUsername__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/utils/DataTransform/getUsername.ts");
/* harmony import */ var _utils_WikiUtils_getWikiImageUrl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("./src/utils/WikiUtils/getWikiImageUrl.ts");
/* harmony import */ var _data_Constants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("./src/data/Constants.ts");
/* harmony import */ var _components_Elements_Image_Image__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("./src/components/Elements/Image/Image.tsx");













const WikiPreviewCard = (param)=>{
    let { wiki , showLatestEditor =false , lastUpdated  } = param;
    var ref, ref1, ref2, ref3, ref4;
    const { updated , title , id  } = wiki;
    const [, userENSDomain] = (0,_hooks_useENSData__WEBPACK_IMPORTED_MODULE_3__/* .useENSData */ .L)(((ref = wiki.user) === null || ref === void 0 ? void 0 : ref.id) || "");
    const getLatestEdited = ()=>{
        let lastEditedTime = null;
        if (updated) {
            lastEditedTime = (0,_utils_DataTransform_getFormattedDate__WEBPACK_IMPORTED_MODULE_10__/* .getReadableDate */ ._)(updated);
        } else if (lastUpdated) {
            lastEditedTime = (0,_utils_DataTransform_getFormattedDate__WEBPACK_IMPORTED_MODULE_10__/* .getReadableDate */ ._)(lastUpdated);
        }
        return lastEditedTime;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .LinkBox */ .fG, {
        w: "100%",
        h: "100%",
        bgColor: "cardBg",
        boxShadow: "xl",
        rounded: "lg",
        overflow: "hidden",
        cursor: "pointer",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .AspectRatio */ .oM, {
                w: "100%",
                ratio: _data_Constants__WEBPACK_IMPORTED_MODULE_12__/* .WIKI_IMAGE_ASPECT_RATIO */ .ag,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Elements_Image_Image__WEBPACK_IMPORTED_MODULE_9__/* .Image */ .E, {
                    src: (0,_utils_WikiUtils_getWikiImageUrl__WEBPACK_IMPORTED_MODULE_8__/* .getWikiImageUrl */ .A)(wiki.images),
                    alt: wiki.title,
                    boxSize: "100%",
                    imgBoxSize: _data_Constants__WEBPACK_IMPORTED_MODULE_12__/* .IMAGE_BOX_SIZE */ .xh
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Stack */ .Kq, {
                spacing: 3,
                p: 4,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Elements_LinkElements_LinkOverlay__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        href: "/wiki/".concat(id),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .xv, {
                            fontSize: "xl",
                            fontWeight: "bold",
                            noOfLines: 1,
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            orientation: "vertical",
                            children: (0,_utils_textUtils__WEBPACK_IMPORTED_MODULE_4__/* .shortenText */ .El)(title, 65)
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Flex */ .kC, {
                        h: "95",
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .xu, {
                                flex: "1",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .xv, {
                                    fontSize: "md",
                                    opacity: 0.7,
                                    noOfLines: 2,
                                    textOverflow: "ellipsis",
                                    overflow: "hidden",
                                    orientation: "vertical",
                                    children: wiki.summary
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Spacer */ .LZ, {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .xu, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .HStack */ .Ug, {
                                    flexWrap: "wrap",
                                    mt: 2,
                                    justify: "space-between",
                                    children: [
                                        showLatestEditor && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .HStack */ .Ug, {
                                            fontSize: "sm",
                                            py: 2,
                                            color: "brandLinkColor",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Elements_Avatar_DisplayAvatar__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                    address: (ref1 = wiki.user) === null || ref1 === void 0 ? void 0 : ref1.id,
                                                    avatarIPFS: (ref2 = wiki.user.profile) === null || ref2 === void 0 ? void 0 : ref2.avatar,
                                                    alt: (ref3 = wiki.user.profile) === null || ref3 === void 0 ? void 0 : ref3.username
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Elements__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .rU, {
                                                    href: "/account/".concat((ref4 = wiki.user) === null || ref4 === void 0 ? void 0 : ref4.id),
                                                    children: (0,_utils_DataTransform_getUsername__WEBPACK_IMPORTED_MODULE_7__/* .getUsername */ .M)(wiki.user, userENSDomain)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .xv, {
                                            py: 2,
                                            m: "0px !important",
                                            color: "gray.400",
                                            fontSize: "sm",
                                            children: [
                                                "Last Edited ",
                                                getLatestEdited()
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WikiPreviewCard);


/***/ }),

/***/ "./src/hooks/useInfiniteData.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ useInfiniteData; }
/* harmony export */ });
/* harmony import */ var _data_Constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/data/Constants.ts");
/* harmony import */ var _store_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/store/store.ts");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");



const useInfiniteData = function(opts) {
    let initialData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    const [hasMore, setHasMore] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const [data, setData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialData);
    const [offset, setOffset] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(opts.defaultLoading || false);
    const updatedOffset = offset + _data_Constants__WEBPACK_IMPORTED_MODULE_2__/* .ITEM_PER_PAGE */ .BJ;
    const fetcher = (noOffset)=>{
        if (loading) return;
        const fetchNewWikis = async ()=>{
            const result = await _store_store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch(opts.initiator.initiate({
                ...opts.arg,
                limit: _data_Constants__WEBPACK_IMPORTED_MODULE_2__/* .ITEM_PER_PAGE */ .BJ,
                offset: noOffset ? 0 : updatedOffset
            }));
            const { data: resData  } = result;
            if (resData && resData.length > 0) {
                setData((prevData)=>[
                        ...prevData,
                        ...resData
                    ]);
                setOffset(updatedOffset);
                if (resData.length < _data_Constants__WEBPACK_IMPORTED_MODULE_2__/* .ITEM_PER_PAGE */ .BJ) setHasMore(false);
                else setHasMore(true);
                if (resData.length === 0) setHasMore(false);
            } else {
                setHasMore(false);
            }
            setLoading(false);
        };
        setLoading(true);
        setTimeout(fetchNewWikis, _data_Constants__WEBPACK_IMPORTED_MODULE_2__/* .FETCH_DELAY_TIME */ .Nf);
    };
    return {
        fetcher,
        hasMore,
        setHasMore,
        setLoading,
        data,
        setData,
        loading,
        offset,
        setOffset
    };
};


/***/ }),

/***/ "./src/pages/categories/[category].tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _category_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("./node_modules/react/jsx-runtime.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__("./node_modules/next-seo/lib/next-seo.module.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/spinner/dist/index.esm.js
var dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/spinner/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/button/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react-infinite-scroll-hook/dist/react-infinite-scroll-hook.esm.js + 1 modules
var react_infinite_scroll_hook_esm = __webpack_require__("./node_modules/react-infinite-scroll-hook/dist/react-infinite-scroll-hook.esm.js");
// EXTERNAL MODULE: ./src/components/Wiki/WikiPreviewCard/WikiPreviewCard.tsx
var WikiPreviewCard = __webpack_require__("./src/components/Wiki/WikiPreviewCard/WikiPreviewCard.tsx");
// EXTERNAL MODULE: ./src/services/wikis/index.ts
var services_wikis = __webpack_require__("./src/services/wikis/index.ts");
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__("./node_modules/next/router.js");
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__("./node_modules/react-i18next/dist/es/useTranslation.js");
// EXTERNAL MODULE: ./src/hooks/useInfiniteData.ts
var useInfiniteData = __webpack_require__("./src/hooks/useInfiniteData.ts");
// EXTERNAL MODULE: ./src/components/Elements/Image/Image.tsx
var Image = __webpack_require__("./src/components/Elements/Image/Image.tsx");
;// CONCATENATED MODULE: ./src/components/Categories/CategoryHero.tsx




const CategoryHero = (param)=>{
    let { id , title , description  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        pos: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                priority: true,
                src: "/images/categories/".concat(id, ".jpg"),
                height: "250px",
                alt: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                zIndex: "2",
                pos: "absolute",
                top: "0",
                justifyContent: "center",
                alignItems: "center",
                left: "0",
                h: "full",
                w: "full",
                direction: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                        fontSize: {
                            base: 25,
                            lg: 36
                        },
                        maxW: "80%",
                        mx: "auto",
                        textAlign: "center",
                        as: "h1",
                        color: "whiteAlpha.900",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                        textAlign: "center",
                        justifyContent: "center",
                        fontWeight: "400",
                        maxW: {
                            base: "90%",
                            md: "70%",
                            lg: "60%"
                        },
                        mx: "auto",
                        px: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            my: 4,
                            mx: {
                                base: "1",
                                md: "8",
                                lg: "14"
                            },
                            color: "whiteAlpha.900",
                            children: description || ""
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                bgColor: "black",
                opacity: "0.65",
                pos: "absolute",
                top: "0",
                left: "0",
                w: "full",
                h: "full",
                zIndex: "1"
            })
        ]
    });
};
/* harmony default export */ var Categories_CategoryHero = (CategoryHero);

// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var ri_index_esm = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");
;// CONCATENATED MODULE: ./src/utils/DataTransform/changeCategoryTitle.ts
const TranformCategoryTitle = (categoryType)=>{
    let title;
    switch(categoryType){
        case "NFTs":
            title = "NFT";
            break;
        case "Dapps":
            title = "Dapp";
            break;
        case "Cryptocurrencies":
            title = "Cryptocurrency";
            break;
        case "Exchanges":
            title = "Exchange";
            break;
        case "DAOs":
            title = "DAO";
            break;
        case "Organizations":
            title = "Organization";
            break;
        default:
            title = categoryType;
    }
    return title;
};

// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var icon_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/icon/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/index.esm.js + 5 modules
var system_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/system/dist/index.esm.js");
// EXTERNAL MODULE: ./src/data/Constants.ts
var Constants = __webpack_require__("./src/data/Constants.ts");
// EXTERNAL MODULE: ./src/utils/DataTransform/getUsername.ts
var getUsername = __webpack_require__("./src/utils/DataTransform/getUsername.ts");
// EXTERNAL MODULE: ./src/utils/DataTransform/getFormattedDate.ts
var getFormattedDate = __webpack_require__("./src/utils/DataTransform/getFormattedDate.ts");
// EXTERNAL MODULE: ./src/utils/WikiUtils/getWikiImageUrl.ts
var getWikiImageUrl = __webpack_require__("./src/utils/WikiUtils/getWikiImageUrl.ts");
// EXTERNAL MODULE: ./src/components/Elements/Avatar/DisplayAvatar.tsx
var DisplayAvatar = __webpack_require__("./src/components/Elements/Avatar/DisplayAvatar.tsx");
// EXTERNAL MODULE: ./src/components/Elements/LinkElements/LinkOverlay.tsx
var LinkOverlay = __webpack_require__("./src/components/Elements/LinkElements/LinkOverlay.tsx");
// EXTERNAL MODULE: ./src/components/Elements/LinkElements/Link.tsx
var Link = __webpack_require__("./src/components/Elements/LinkElements/Link.tsx");
;// CONCATENATED MODULE: ./src/components/Categories/TrendingCategoryItem.tsx











const TrendingCategoryItem = (props)=>{
    var ref, ref1;
    const { wikiId , title , WikiImgObj , brief , editor , lastModTimeStamp  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* LinkBox */.fG, {
        bgColor: "cardBg",
        borderRadius: "12px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
            gap: {
                base: 2,
                md: "5"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                    alignSelf: {
                        base: "center",
                        md: "initial"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AspectRatio */.oM, {
                        ratio: Constants/* WIKI_IMAGE_ASPECT_RATIO */.ag,
                        w: {
                            base: "149px",
                            md: "226px"
                        },
                        h: {
                            base: "124",
                            md: "200px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            src: (0,getWikiImageUrl/* getWikiImageUrl */.A)(WikiImgObj),
                            imgW: Constants/* IMAGE_BOX_SIZE */.xh * Constants/* WIKI_IMAGE_ASPECT_RATIO */.ag,
                            imgH: Constants/* IMAGE_BOX_SIZE */.xh,
                            alt: "trending wiki image",
                            w: "full",
                            h: "full",
                            borderRadius: "6px",
                            objectFit: "cover"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                    flexGrow: "1",
                    alignSelf: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkOverlay/* default */.Z, {
                            href: "/wiki/".concat(wikiId),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                cursor: "pointer",
                                maxW: "90%",
                                fontSize: {
                                    base: "16px",
                                    md: "20px"
                                },
                                children: title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            noOfLines: {
                                base: 2,
                                md: 3
                            },
                            color: "homeDescriptionColor",
                            my: 2,
                            display: "-webkit-box",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            fontSize: {
                                base: "12px",
                                md: "14px"
                            },
                            children: brief
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                            mt: "2.5",
                            gap: "3",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayAvatar/* default */.Z, {
                                    address: editor.id,
                                    avatarIPFS: (ref = editor.profile) === null || ref === void 0 ? void 0 : ref.avatar,
                                    alt: (ref1 = editor.profile) === null || ref1 === void 0 ? void 0 : ref1.username
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "/account/".concat(editor.id),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        fontSize: {
                                            base: "10px",
                                            md: "14px"
                                        },
                                        color: "brandLinkColor",
                                        fontWeight: "bold",
                                        children: (0,getUsername/* getUsername */.M)(editor)
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                            mt: "4px !important",
                            fontSize: {
                                base: "10px",
                                md: "14px"
                            },
                            opacity: 0.6,
                            whiteSpace: "nowrap",
                            children: [
                                "Last Edited ",
                                (0,getFormattedDate/* getReadableDate */._)(lastModTimeStamp),
                                " ago"
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Categories_TrendingCategoryItem = (TrendingCategoryItem);

// EXTERNAL MODULE: ./node_modules/embla-carousel-autoplay/embla-carousel-autoplay.esm.js
var embla_carousel_autoplay_esm = __webpack_require__("./node_modules/embla-carousel-autoplay/embla-carousel-autoplay.esm.js");
// EXTERNAL MODULE: ./src/components/Elements/Carousel/Carousel.tsx
var Carousel = __webpack_require__("./src/components/Elements/Carousel/Carousel.tsx");
;// CONCATENATED MODULE: ./src/components/Categories/TrendingCategoryCard.tsx






const TrendingCategoryCard = (param)=>{
    let { title , icon , wikis  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        bgColor: "cardBg",
        boxShadow: "md",
        p: {
            base: "2.5",
            md: "5"
        },
        borderRadius: "12px",
        overflowX: "hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                mb: {
                    base: "1",
                    md: "2"
                },
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                        cursor: "pointer",
                        fontSize: "2xl",
                        fontWeight: 600,
                        color: "brandLinkColor",
                        as: icon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        fontSize: {
                            base: "14px",
                            lg: "18px"
                        },
                        pl: 2,
                        fontWeight: "600",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* WikiCarousel */.B, {
                data: wikis,
                item: (wiki)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.div */.m$.div, {
                        px: {
                            base: "1",
                            md: "4"
                        },
                        py: "2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Categories_TrendingCategoryItem, {
                            title: wiki.title,
                            WikiImgObj: wiki.images,
                            brief: wiki.summary,
                            editor: wiki.user,
                            lastModTimeStamp: wiki.updated,
                            wikiId: wiki.id
                        })
                    }, "wiki-".concat(wiki.id)),
                plugins: [
                    (0,embla_carousel_autoplay_esm/* default */.Z)()
                ]
            })
        ]
    });
};
/* harmony default export */ var Categories_TrendingCategoryCard = (TrendingCategoryCard);

;// CONCATENATED MODULE: ./src/components/Categories/TrendingCategoriesWiki.tsx






const TrendingCategoriesWiki = (param)=>{
    let { categoryType , trending , newWikis  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
        width: {
            base: "90%",
            lg: "min(80%, 1300px)"
        },
        mx: "auto",
        my: {
            base: "10",
            md: "16"
        },
        gridTemplateColumns: {
            base: "repeat(1, 1fr)",
            xl: "repeat(2, 1fr)"
        },
        gap: "5",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Categories_TrendingCategoryCard, {
                icon: ri_index_esm/* RiBarChartFill */.jwm,
                title: "Popular ".concat(TranformCategoryTitle(categoryType), " Wikis"),
                wikis: trending
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Categories_TrendingCategoryCard, {
                icon: ri_index_esm/* RiTimeFill */.N$g,
                title: "New ".concat(TranformCategoryTitle(categoryType), " Wikis"),
                wikis: newWikis
            })
        ]
    });
};
/* harmony default export */ var Categories_TrendingCategoriesWiki = (TrendingCategoriesWiki);

;// CONCATENATED MODULE: ./src/pages/categories/[category].tsx












// TODO: load page 4 or 5 times. probably useInfiniteData doing rerenderings bcs of state changing. review
// TODO: i added a new param to allow inject directly data, instead of using an effect. it can be fixed in all places
const CategoryPage = (param)=>{
    let { categoryData , wikis , trending , newWikis  } = param;
    const router = (0,next_router.useRouter)();
    const category = router.query.category;
    const { data: wikisInCategory , fetcher: fetchMoreWikis , loading , hasMore  } = (0,useInfiniteData/* useInfiniteData */.c)({
        initiator: services_wikis/* getWikisByCategory */.SS,
        arg: {
            category
        }
    }, wikis);
    const [sentryRef] = (0,react_infinite_scroll_hook_esm/* default */.Z)({
        loading,
        hasNextPage: hasMore,
        onLoadMore: fetchMoreWikis
    });
    const { t  } = (0,useTranslation/* useTranslation */.$)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            categoryData && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: categoryData.title,
                description: categoryData.description,
                openGraph: {
                    title: categoryData.title,
                    description: categoryData.description,
                    images: [
                        {
                            url: "/images/categories/".concat(categoryData.id, ".jpg")
                        }
                    ]
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                mt: "-3",
                bgColor: "pageBg",
                pb: 12,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Categories_CategoryHero, {
                        id: categoryData === null || categoryData === void 0 ? void 0 : categoryData.id,
                        description: categoryData === null || categoryData === void 0 ? void 0 : categoryData.description,
                        title: categoryData === null || categoryData === void 0 ? void 0 : categoryData.title
                    }),
                    (trending.length > 0 || newWikis.length > 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Categories_TrendingCategoriesWiki, {
                        categoryType: categoryData === null || categoryData === void 0 ? void 0 : categoryData.title,
                        trending: trending,
                        newWikis: newWikis
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Divider */.iz, {
                        opacity: "1",
                        borderColor: "gray.300",
                        _dark: {
                            borderColor: "whiteAlpha.200"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                        mt: 10,
                        children: wikisInCategory.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
                                    columns: {
                                        base: 1,
                                        sm: 2,
                                        lg: 3
                                    },
                                    width: {
                                        base: "90%",
                                        lg: "min(80%, 1300px)"
                                    },
                                    mx: "auto",
                                    my: 10,
                                    gap: 8,
                                    children: wikisInCategory.map((wiki, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WikiPreviewCard/* default */.Z, {
                                                wiki: wiki,
                                                showLatestEditor: true
                                            })
                                        }, i))
                                }),
                                loading || hasMore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                    ref: sentryRef,
                                    mt: "10",
                                    w: "full",
                                    h: "16",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Spinner */.$, {
                                        size: "xl"
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                    mt: "10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        fontWeight: "semibold",
                                        children: t("seenItAll")
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                            textAlign: "center",
                            py: 10,
                            px: 6,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    fontSize: "lg",
                                    mt: 3,
                                    mb: 3,
                                    children: "Oops, No Wiki Found in This Category"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                    colorScheme: "primary",
                                    color: "white",
                                    variant: "solid",
                                    onClick: ()=>router.back(),
                                    children: "Go Back"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _category_ = (CategoryPage);


/***/ }),

/***/ "./src/utils/DataTransform/getFormattedDate.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ getReadableDate; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/date-fns/esm/formatDistanceToNowStrict/index.js");

const getReadableDate = (dateToFormat)=>{
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Date(dateToFormat), {
        addSuffix: false
    });
};


/***/ }),

/***/ "./src/utils/DataTransform/getUsername.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ getUsername; }
/* harmony export */ });
/* harmony import */ var _textUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/utils/textUtils.ts");

const getUsername = (user, ensDomain)=>{
    var ref;
    if (!user) {
        return "Unknown";
    }
    if ((ref = user.profile) === null || ref === void 0 ? void 0 : ref.username) {
        return user.profile.username;
    }
    if (ensDomain) {
        return ensDomain;
    }
    return user.id ? (0,_textUtils__WEBPACK_IMPORTED_MODULE_0__/* .shortenAccount */ .p0)(user.id) : "Unknown";
};


/***/ }),

/***/ "./src/utils/WikiUtils/getWikiImageUrl.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ getWikiImageUrl; }
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/config/index.ts");

const getWikiImageUrl = (imageObj)=>{
    var ref;
    return "".concat(_config__WEBPACK_IMPORTED_MODULE_0__/* ["default"].pinataBaseUrl */ .Z.pinataBaseUrl).concat(imageObj ? (ref = imageObj[0]) === null || ref === void 0 ? void 0 : ref.id : "");
};


/***/ }),

/***/ "./src/utils/textUtils.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ei": function() { return /* binding */ slugifyText; },
/* harmony export */   "El": function() { return /* binding */ shortenText; },
/* harmony export */   "TY": function() { return /* binding */ lettersToNum; },
/* harmony export */   "Zw": function() { return /* binding */ isVerifiedContentLinks; },
/* harmony export */   "jv": function() { return /* binding */ isValidUrl; },
/* harmony export */   "lK": function() { return /* binding */ shortenBalance; },
/* harmony export */   "p0": function() { return /* binding */ shortenAccount; }
/* harmony export */ });
/* unused harmony export shortenMediaText */
/* harmony import */ var _everipedia_iq_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/@everipedia/iq-utils/build/module/index.js");
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/slugify/slugify.js");
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(slugify__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var humanize_plus__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/humanize-plus/dist/humanize.js");
/* harmony import */ var humanize_plus__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(humanize_plus__WEBPACK_IMPORTED_MODULE_2__);



const lettersToNum = (str)=>{
    let out = 0;
    const len = str.length;
    for(let pos = 0; pos < len; pos += 1){
        out += (str.charCodeAt(pos) - 64) * 26 ** (len - pos - 1);
    }
    return out;
};
const shortenAccount = function(account) {
    let firstTakeLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, secondTakeLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 4;
    const firstChunk = account.substring(0, firstTakeLength);
    const secondChunk = account.substring(account.length - secondTakeLength);
    return "".concat(firstChunk, "...").concat(secondChunk);
};
const shortenBalance = (balance)=>typeof balance === "number" ? humanize_plus__WEBPACK_IMPORTED_MODULE_2__.formatNumber(balance, 2) : balance;
const shortenText = (text, length)=>{
    return (text === null || text === void 0 ? void 0 : text.length) > length ? "".concat(text.substring(0, length), "...") : text;
};
const shortenMediaText = (name)=>{
    const nameArray = name.split(".");
    return nameArray[0].length > 6 ? "".concat(nameArray[0].substring(0, 6), "....").concat(nameArray[1]) : name;
};
const slugifyText = (text)=>{
    return slugify__WEBPACK_IMPORTED_MODULE_1___default()(text.toLowerCase(), {
        strict: true,
        lower: true,
        remove: /[*+~.()'"!:@]/g
    });
};
const isValidUrl = (urlString)=>{
    try {
        return Boolean(new URL(urlString));
    } catch (_e) {
        return false;
    }
};
const isVerifiedContentLinks = (content)=>{
    const markdownLinks = content.match(/\[(.*?)\]\((.*?)\)/g);
    let isValid = true;
    markdownLinks === null || markdownLinks === void 0 ? void 0 : markdownLinks.every((link)=>{
        const linkMatch = link.match(/\[(.*?)\]\((.*?)\)/);
        const text = linkMatch === null || linkMatch === void 0 ? void 0 : linkMatch[1];
        const url = linkMatch === null || linkMatch === void 0 ? void 0 : linkMatch[2];
        if (text && url && _everipedia_iq_utils__WEBPACK_IMPORTED_MODULE_0__/* .whiteListedLinkNames.includes */ .Kp.includes(text) && !isValidUrl(url)) {
            isValid = true;
            return true;
        }
        if (url && url.charAt(0) !== "#") {
            const validURLRecognizer = new RegExp("^https?://(www\\.)?(".concat(_everipedia_iq_utils__WEBPACK_IMPORTED_MODULE_0__/* .whiteListedDomains.join */ .xw.join("|"), ")"));
            isValid = validURLRecognizer.test(url);
            return isValid;
        }
        return true;
    });
    return isValid;
};


/***/ }),

/***/ "./node_modules/react-infinite-scroll-hook/dist/react-infinite-scroll-hook.esm.js":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ react_infinite_scroll_hook_esm; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
;// CONCATENATED MODULE: ./node_modules/react-intersection-observer-hook/dist/react-intersection-observer-hook.esm.js


var DEFAULT_ROOT_MARGIN = '0px';
var DEFAULT_THRESHOLD = [0]; // For more info:
// https://developers.google.com/web/updates/2016/04/intersectionobserver
// https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API

function useIntersectionObserver(args) {
  var _args$rootMargin, _args$threshold;

  var rootMargin = (_args$rootMargin = args == null ? void 0 : args.rootMargin) != null ? _args$rootMargin : DEFAULT_ROOT_MARGIN;
  var threshold = (_args$threshold = args == null ? void 0 : args.threshold) != null ? _args$threshold : DEFAULT_THRESHOLD;
  var nodeRef = (0,react.useRef)(null);
  var rootRef = (0,react.useRef)(null);
  var observerRef = (0,react.useRef)(null);

  var _useState = (0,react.useState)(),
      entry = _useState[0],
      setEntry = _useState[1];

  var unobserve = (0,react.useCallback)(function () {
    // Disconnect the current observer (if there is one)
    var currentObserver = observerRef.current;
    currentObserver == null ? void 0 : currentObserver.disconnect();
    observerRef.current = null;
  }, []);
  var observe = (0,react.useCallback)(function () {
    var node = nodeRef.current;

    if (node) {
      var root = rootRef.current;
      var options = {
        root: root,
        rootMargin: rootMargin,
        threshold: threshold
      }; // Create a observer for current "node" with given options.

      var observer = new IntersectionObserver(function (_ref) {
        var newEntry = _ref[0];
        setEntry(newEntry);
      }, options);
      observer.observe(node);
      observerRef.current = observer;
    }
  }, [rootMargin, threshold]);
  var initializeObserver = (0,react.useCallback)(function () {
    unobserve();
    observe();
  }, [observe, unobserve]);
  var refCallback = (0,react.useCallback)(function (node) {
    nodeRef.current = node;
    initializeObserver();
  }, [initializeObserver]);
  var rootRefCallback = (0,react.useCallback)(function (rootNode) {
    rootRef.current = rootNode;
    initializeObserver();
  }, [initializeObserver]);
  (0,react.useEffect)(function () {
    // After React 18, StrictMode unmounts and mounts components to be sure
    // if they are resilient effects being mounted and destroyed multiple times.
    // This a behavior to be sure nothing breaks when off-screen components
    // can preserve their state with future React versions.
    // So in StrictMode, React unmounts the component, clean-up of this useEffect gets triggered and
    // we stop observing the node. But we need to start observing after component re-mounts with its preserved state.
    // So to handle this case, we call initializeObserver here.
    // https://reactjs.org/blog/2022/03/08/react-18-upgrade-guide.html#updates-to-strict-mode
    initializeObserver();
    return function () {
      // We disconnect the observer on unmount to prevent memory leaks etc.
      unobserve();
    };
  }, [initializeObserver, unobserve]);
  return [refCallback, {
    entry: entry,
    rootRef: rootRefCallback
  }];
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function useTrackVisibility(args) {
  var _result$entry;

  var _useIntersectionObser = useIntersectionObserver(args),
      ref = _useIntersectionObser[0],
      result = _useIntersectionObser[1];

  var isVisible = Boolean((_result$entry = result.entry) == null ? void 0 : _result$entry.isIntersecting);

  var _useState = (0,react.useState)(isVisible),
      wasEverVisible = _useState[0],
      setWasEverVisible = _useState[1];

  (0,react.useEffect)(function () {
    if (isVisible) {
      setWasEverVisible(isVisible);
    }
  }, [isVisible]);
  return [ref, _extends({}, result, {
    isVisible: isVisible,
    wasEverVisible: wasEverVisible
  })];
}


//# sourceMappingURL=react-intersection-observer-hook.esm.js.map

;// CONCATENATED MODULE: ./node_modules/react-infinite-scroll-hook/dist/react-infinite-scroll-hook.esm.js



var DEFAULT_DELAY_IN_MS = 100;

function useInfiniteScroll(_ref) {
  var loading = _ref.loading,
      hasNextPage = _ref.hasNextPage,
      onLoadMore = _ref.onLoadMore,
      rootMargin = _ref.rootMargin,
      disabled = _ref.disabled,
      _ref$delayInMs = _ref.delayInMs,
      delayInMs = _ref$delayInMs === void 0 ? DEFAULT_DELAY_IN_MS : _ref$delayInMs;

  var _useTrackVisibility = useTrackVisibility({
    rootMargin: rootMargin
  }),
      ref = _useTrackVisibility[0],
      _useTrackVisibility$ = _useTrackVisibility[1],
      rootRef = _useTrackVisibility$.rootRef,
      isVisible = _useTrackVisibility$.isVisible;

  var shouldLoadMore = !disabled && !loading && isVisible && hasNextPage; // eslint-disable-next-line consistent-return

  (0,react.useEffect)(function () {
    if (shouldLoadMore) {
      // When we trigger 'onLoadMore' and new items are added to the list,
      // right before they become rendered on the screen, 'loading' becomes false
      // and 'isVisible' can be true for a brief time, based on the scroll position.
      // So, it triggers 'onLoadMore' just after the first one is finished.
      // We use a small delay here to prevent this kind of situations.
      // It can be configured by hook args.
      var timer = setTimeout(function () {
        onLoadMore();
      }, delayInMs);
      return function () {
        clearTimeout(timer);
      };
    }
  }, [onLoadMore, shouldLoadMore, delayInMs]);
  return [ref, {
    rootRef: rootRef
  }];
}

/* harmony default export */ var react_infinite_scroll_hook_esm = (useInfiniteScroll);
//# sourceMappingURL=react-infinite-scroll-hook.esm.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,1228,5675,2192,7249,8764,5619,4095,6788,6422,4116,892,8283,9774,2888,179], function() { return __webpack_exec__("./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Fcategories%2F%5Bcategory%5D.tsx&page=%2Fcategories%2F%5Bcategory%5D!"); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);